
<template>
    <div id="VehicleInfo" class="VehicleInfo">
        <div class="nav">
            <row>
                <van-col span="2">
                    <Icon name="arrow-left" size="26" @click="getBack" />
                </van-col>
                <van-col span="18" align="center" justify="center" style="font-size:19px;">结算单详情</van-col>
            </row>

        </div>

        <div class="MainContent">
            <row class="ContentBtn">
                <van-button span="18" class="btn" @click="jump">维修信息</van-button>
                <van-button span="18" class="btn" style="float:right;margin-right:1.5em">基本信息</van-button>
            </row>
            <div style="border-bottom:1px solid gray;line-height:1px; height:1px; padding:0; margin:0;" />
            <row class="Contentlist">
                <van-col class="colTitle">车辆编号</van-col>
                <van-col class="colContent">{{ vehicleInfo.vehicleCode }}</van-col>
            </row>
            <div style="border-bottom:1px solid gray;line-height:1px; height:1px; padding:0; margin:0;" />
            <row class="Contentlist">
                <van-col class="colTitle">机号</van-col>
                <van-col class="colContent">{{ vehicleInfo.chassisNumber }}</van-col>
            </row>
            <div style="border-bottom:1px solid gray;line-height:1px; height:1px; padding:0; margin:0;" />
            <div style="border-bottom:1px solid gray;line-height:1px; height:1px; padding:0; margin:0;" />
            <row class="Contentlist">
                <van-col class="colTitle">车辆类别</van-col>
                <van-col class="colContent">{{ vehicleInfo.category }}</van-col>
            </row>
            <div style="border-bottom:1px solid gray;line-height:1px; height:1px; padding:0; margin:0;" />
            <row class="Contentlist">
                <van-col class="colTitle">车辆型号</van-col>
                <van-col class="colContent">{{ vehicleInfo.model }}</van-col>
            </row>
            <div style="border-bottom:1px solid gray;line-height:1px; height:1px; padding:0; margin:0;" />
            <div style="border-bottom:1px solid gray;line-height:1px; height:1px; padding:0; margin:0;" />
            <row class="Contentlist">
                <van-col class="colTitle">品牌</van-col>
                <van-col class="colContent">{{ vehicleInfo.brand }}</van-col>
            </row>
            <div style="border-bottom:1px solid gray;line-height:1px; height:1px; padding:0; margin:0;" />
            <row class="Contentlist">
                <van-col class="colTitle">入场日期</van-col>
                <van-col class="colContent">{{ vehicleInfo.entryTime }}</van-col>
            </row>
            <div style="border-bottom:1px solid gray;line-height:1px; height:1px; padding:0; margin:0;" />
            <div style="border-bottom:1px solid gray;line-height:1px; height:1px; padding:0; margin:0;" />
            <row class="Contentlist">
                <van-col class="colTitle">客户名称</van-col>
                <van-col class="colContent">{{ vehicleInfo.customer }}</van-col>
            </row>
            <!-- <div style="border-bottom:1px solid gray;line-height:1px; height:1px; padding:0; margin:0;" />
            <row class="Contentlist">
                <van-col class="colTitle">电话</van-col>
                <van-col class="colContent">{{ vehicleInfo.phone }}</van-col>
            </row> -->
            <div style="border-bottom:1px solid gray;line-height:1px; height:1px; padding:0; margin:0;" />
            <row class="Contentlist">
                <van-col class="colTitle">权责人</van-col>
                <van-col class="colContent">{{ vehicleInfo.owner }}</van-col>
            </row>
            <div style="border-bottom:1px solid gray;line-height:1px; height:1px; padding:0; margin:0;" />
            <row class="Contentlist">
                <van-col class="colTitle">驾驶员姓名</van-col>
                <van-col class="colContent">{{ vehicleInfo.driver }}</van-col>
            </row>
            <div style="border-bottom:1px solid gray;line-height:1px; height:1px; padding:0; margin:0;" />
            <row class="Contentlist">
                <van-col class="colTitle">驾驶员电话</van-col>
                <van-col class="colContent">{{ vehicleInfo.driverPhone }}</van-col>
            </row>
            <div style="border-bottom:1px solid gray;line-height:1px; height:1px; padding:0; margin:0;" />

        </div>
        <div style="width:100%; bottom:50px;position:fixed; background:whitesmoke">
            <row class="Contentlist">
                <van-col class="colTitle">金额:</van-col><van-col class="colTitle">{{ stateDetail.total }}</van-col>
                <van-col class="colTitle">司机签字</van-col> <van-col class="colTitle">{{ stateDetail.driver }}</van-col>
                <van-col class="colTitle" style="float:right"><icon name="coupon" color="#f58220" size="30" /></van-col>
            </row>
            <row class="Contentlist">
                <van-button class="btn">维修信息</van-button>
                <van-button class="btn" style="float:right;margin-right:1.5em">基本信息</van-button>
            </row>
        </div>
        <bottom />
    </div>
</template>
<script>
import { Icon, Button, Col, Row, Search } from 'vant'
import bottom from '@/components/bottom'
import { getVehicleInfo, getStateDetail } from '@/api/maintain'
export default {
    name: 'StatementListDetail',
    components: {
        bottom,
        Icon, [Button.name]: Button, [Col.name]: Col, Row, Search
    },
    data() {
        return {
            vehicleInfo: {},
            stateDetail: {}
        }
    },
    created() {
        console.log('###################################################################################################################')
        getStateDetail('5b1c5780-9510-427e-b638-bbb9a3f2103e').then(async response => {
            console.log(response.data)
            this.stateDetail = response.data
        })
        // this.stateDetail.entranceId
        getVehicleInfo('5b1c5780-9510-427e-b638-bbb9a3f2103e').then(async response => {
            console.log(response.data)
            this.vehicleInfo = response.data
        })
    },
    methods: {
        jump() {
            this.$router.push({ path: '/StatementListDetail' })
        },
        getBack() {
            this.$router.back()
        }
    }
}
</script>
<style  lang="scss" scoped>
.MainContent{
   .ContentBtn{
       width:100%;
       margin-top:10px;
       .btn{
           width: 45%;
              font-size:16px;
              font-weight:bold;
              padding: 0;
              margin:0  0 0 1.5em;
       }

       }
.Contentlist{
    background:white;
   .colTitle{
              width: 15%;
              margin:0 0 0 1.5em;
              font-size:16px;
              font-weight:bold;
              }
              .colContent{
              width: 45%;
              font-size:14px;
              text-align: right;
              margin:0 1.5em 0 0;
       }
}

}
.VehicleInfo{
  width: 100%;
  background: whitesmoke;
  .logout{
    margin-top: -20px;
    color: blue;
  }
   .list_inner{height: 170px;}
   .list{height: 150px;float: left;position: relative;width:100%}
  .clientList{
    padding: 0px 40px;
    h2{
      font-size: 32px;
      font-weight: 700;
      margin-bottom: 25px;
    }
    .select{
               width                    : 10em;
               height                   : 2.2em;
               padding                  : 0.2em 0.4em 0.2em 0.4em;
               vertical-align           : middle;
               border                   : 1px solid lightgray;
               -moz-border-radius       : 0.2em;
               -webkit-border-radius    : 0.2em;
               border-radius            : 0.2em;
               -webkit-appearance       : none;
               -moz-appearance          : none;
               appearance               : none;
               background               : #ffffff;
               font-family              : SimHei;
               font-size                : 1.1em;
               color                    : RGBA(22,22,22,0.7);
               cursor                   : pointer;
        }
    .selectLabel{
               width                    : 8em;
               height                   : 2.2em;
               padding                  : 0.4em 0.4em 0.2em 1.2em;
               vertical-align           : middle;
               border-radius            : 0.2em;
               background               : #ffffff;
               font-family              : SimHei;
               font-size                : 1.3em;
               color                    : RGBA(22,22,22,0.7);

    }
  }
}
.orderCode{
        background: #07C160;
        padding: 0 5px 0 5px;
}

.nav{
  width: 100%;
  padding: 20px 0px;
  background: #3498ff;
  color: #fff;
  .nav-title{
    width: 100%;
    font-size: 30px;
    text-align: center;
    display: block;
  }
}
.ListCode{
    font-size:23px;
    padding: 0.2em 0.4em 0.2em 0.4em;
    margin: 0.2em 0.4em 0.2em 1.1em;
    text-align: left;
    display:inline;
}

.info-span{
    padding: 0.7em 1.4em  0.8em 1.6em;
    margin: 0.2em 0em 0.2em  ;
    font-size:23px;
    color:#000;
}
.info-span-gray{
    padding: 0.7em 1.4em  0.8em 1.6em;
    margin: 0.2em 0em 0.2em ;
    font-size:23px;
    color:gray;
}
</style>
